<template>
    <div class="page-wrapper">
        <navbar></navbar>
        <div class="page-content">
            <div class="row justify-content-center">
                <div class="col-md-8 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="card-title mb-0">Form Subject</div>
                                <router-link :to="{name: 'courses_category'}" class="btn btn-light">Back</router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="card-subtitle mt-0">Please complete the form below.</div>
                            <form class="forms-sample" v-on:submit.prevent="onSubmit">
                                <div class="form-group">
                                    <label for="code">Code</label>
                                    <input type="text" class="form-control" id="code" name="code" autocomplete="off" :class="{ 'is-invalid': submitted && $v.form.code.$error }" v-model="form.code" placeholder="Enter code ...">
                                    <div v-if="submitted && !$v.form.code.required" class="invalid-feedback">Code is required!</div>
                                </div>
                                <div class="form-group">
                                    <label for="name">Name</label>
                                    <input type="text" class="form-control" id="name" name="name" :class="{ 'is-invalid': submitted && $v.form.name.$error }" v-model="form.name" placeholder="Enter name ...">
                                    <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Name is required!</div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="curriculum_id">Curriculum</label>
                                        <multiselect v-model="form.curriculum_id" :options="list_curriculum" placeholder="Choose Curriculum" :show-labels="false" label="name" track-by="name" :class="{ 'is-invalid': submitted && $v.form.curriculum_id.$error }">
                                            <template slot="option" slot-scope="props"><strong>{{ props.option.name }}</strong></template>
                                        </multiselect>
                                        <div v-if="submitted && !$v.form.curriculum_id.required" class="invalid-feedback">Currciulum is required!</div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="program_study_id">Study Program</label>
                                        <multiselect v-model="form.program_study_id" :options="list_study_program" placeholder="Choose Study Program" :show-labels="false" label="name" track-by="name" :class="{ 'is-invalid': submitted && $v.form.program_study_id.$error }">
                                            <template slot="option" slot-scope="props"><strong>{{ props.option.name }}</strong></template>
                                        </multiselect>
                                        <div v-if="submitted && !$v.form.program_study_id.required" class="invalid-feedback">Study Program is required!</div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="sks">Total SKS</label>
                                        <input type="number" class="form-control" id="sks" name="sks" autocomplete="off" :class="{ 'is-invalid': submitted && $v.form.sks.$error }" v-model="form.sks" placeholder="Enter total sks ...">
                                        <div v-if="submitted && !$v.form.sks.required" class="invalid-feedback">Total SKS is required!</div>
                                    </div>
                                    <div class="col-md-6">
                                        <label for="semester">Semester</label>
                                        <input type="number" class="form-control" id="semester" name="semester" autocomplete="off" :class="{ 'is-invalid': submitted && $v.form.semester.$error }" v-model="form.semester" placeholder="Enter total semester ...">
                                        <div v-if="submitted && !$v.form.semester.required" class="invalid-feedback">Semester is required!</div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="status">Status</label>
                                        <select class="form-control" id="status" name="status" :class="{ 'is-invalid': submitted && $v.form.status.$error }" v-model="form.status">
                                            <option value="draft">Draft</option>
                                            <option value="publish">Publish</option>
                                        </select>
                                        <div v-if="submitted && !$v.form.status.required" class="invalid-feedback">Status is required!</div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-end">
                                    <button type="submit" class="btn btn-primary mr-2 mt-2">Save</button>
                                    <router-link :to="{name: 'courses_category'}" class="btn btn-light mt-2">Back</router-link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <foot></foot>
    </div>
</template>
<script>
    import {
        required
    } from "vuelidate/lib/validators";
    
    export default {
        name: 'CoursesCategoryForm',
        metaInfo: {
            title: 'Form Subject',
            titleTemplate: '%s - Unfari E-learning'
        },
        components : {
        },
        created() {
            this.getDataByID(this.$route.params.id);
            this.getCurriculum();
            this.getStudyProgram();
        },
        data() {
            return {
                id              : this.$route.params.id,
                form : {
                    id          : "",
                    code        : "",
                    name        : "",
                    sks         : "",
                    program_study_id    : [],
                    curriculum_id       : [],
                    status              : "draft",
                },
                list_curriculum    : [],
                list_study_program : [],
                submitted       : false,
                waiting         : false
            }
        },
        validations: {
            form: {
                code: {
                    required
                },
                name: {
                    required
                },
                sks: {
                    required
                },
                semester: {
                    required
                },
                program_study_id: {
                    required
                },
                curriculum_id: {
                    required
                },
                status: {
                    required
                },
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Please complete the form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    // get id curriculum
                    this.form.curriculum_id = this.form.curriculum_id['id'];
                    // get id study program
                    this.form.program_study_id = this.form.program_study_id['id'];

                    for (var index in this.form) {
                        formData.append(index, this.form[index]);
                    }

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/courses-category/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'courses_category' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Update";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/courses-category/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;
                            this.form       = getResponse;
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'courses_category' });
                                }
                            });
                        }
                    });
                }
            },
            getCurriculum: function() {
                let uri     = process.env.VUE_APP_APIHOST+'admin/curriculum/list';

                this.$http.get(uri,{
                }).then(res => {
                    if(res.data.status) {
                        this.list_curriculum = res.data.data;
                    }
                });
            },
            getStudyProgram: function() {
                let uri     = process.env.VUE_APP_APIHOST+'admin/program-study/list';

                this.$http.get(uri,{
                }).then(res => {
                    if(res.data.status) {
                        this.list_study_program = res.data.data;
                    }
                });
            },
        }
    }
</script>